import { HttpError } from '@/api/client';

export function ErrorView({ error }: { error: unknown }) {
  const msg = formatError(error);
  return <div className="error-banner">{msg}</div>;
}

// ru.bazakurierov.api.ApiExceptionHandler emits these codes. Its `message` is English free text
// meant for logs, so translate on the code and never render the server's prose.
const BY_CODE: Record<string, string> = {
  not_found: 'Не нашли — возможно, запись уже удалена.',
  unauthorized: 'Не удалось авторизоваться через Telegram.',
  payload_too_large: 'Файлы слишком большие. До 12 МБ на скриншот.',
  validation_error: 'Проверьте введённые данные.',
  bad_request: 'Не удалось выполнить запрос.',
  conflict: 'Сейчас это действие недоступно.',
  internal_error: 'Сервис временно недоступен. Попробуйте позже.',
};

const BY_STATUS: Record<number, string> = {
  401: 'Не удалось авторизоваться через Telegram.',
  403: 'Не удалось авторизоваться через Telegram.',
  404: 'Не нашли — возможно, запись уже удалена.',
  413: 'Файлы слишком большие. До 12 МБ на скриншот.',
};

export function formatError(error: unknown): string {
  if (error instanceof HttpError) {
    if (error.status === 429) {
      const wait = error.retryAfterSeconds ?? 0;
      return `Слишком частые запросы. Попробуйте через ${wait}с.`;
    }
    if (error.status >= 500) return BY_CODE.internal_error;
    return BY_CODE[error.code] ?? BY_STATUS[error.status] ?? 'Не удалось выполнить запрос.';
  }
  // A thrown TypeError from fetch means the request never completed.
  if (error instanceof Error) return 'Нет связи с сервером. Проверьте интернет.';
  return 'Сетевая ошибка. Попробуйте ещё раз.';
}
